var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._l(_vm.groupedItem, function (fruits) {
    return [_c('v-divider'), _c('fruit', {
      key: 'grouped-fruit-' + fruits,
      attrs: {
        "id": fruits
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }